import TabbyWidget from "@/components/Cart/TabbyWidget";
// import ImgTag from "@/components/Helpers/ImgTag";
// import Link from "next/link";
import Tamara from "./Tamara";
import MisPay from "./MisPay";
import { installmentsBy_6_skus } from "@/constants/Global";
import Madfu from "./Madfu";
import useClient from "@/hooks/global/useClient";

const Index = ({ product, locale, isPreorder }) => {
  const { isClient } = useClient();
  const eligible_for_mispay =
    product?.product_attributes?.eligible_for_mispay?.value == 1 ||
    product?.eligible_for_mispay;
  console.log('first', isClient, eligible_for_mispay, isPreorder);
  return (
    <>
      {isClient && !isPreorder && (
        <Madfu
          locale={locale}
          amount={
            product?.prices_with_tax?.price ||
            product?.prices_with_tax?.original_price
          }
        />
      )}
      {product?.eligible_for_tabby?.length &&
      product?.eligible_for_tabby[0] &&
      !isPreorder ? (
        <TabbyWidget
          price={product?.prices_with_tax?.price}
          locale={locale}
          installments={installmentsBy_6_skus.includes(product?.sku) ? 6 : 4}
        />
      ) : null}
      <Tamara
        locale={locale}
        installments={installmentsBy_6_skus.includes(product?.sku) ? 6 : 4}
        amount={
          product?.prices_with_tax?.price ||
          product?.prices_with_tax?.original_price
        }
      />
      {
        eligible_for_mispay && !isPreorder && (
          <MisPay
            locale={locale}
            amount={
              product?.prices_with_tax?.price ||
              product?.prices_with_tax?.original_price
            }
          />
        )}
      {/* {product?.eligible_for_tamara?.length &&
      product?.eligible_for_tamara[0] ? (
        <div className="flex items-center p-1.5 border rounded-md mt-[.5rem]">
          <ImgTag
            src={`${process.env.NEXT_PUBLIC_CLOUD_FLAIR}/w=80&h=36,fit=contain,format=auto,quality=75/tamara.png`}
            className="object-contain w-auto h-9"
            alt="tamara img!"
          />
          <p className="mx-4">
            {locale === "en"
              ? `Pay a minimum of ${
                  truncateToTwoDecimalPlaces(
                    product?.prices_with_tax?.price ==
                      product?.prices_with_tax?.original_price ||
                      product?.prices_with_tax?.discounted_price_to == ""
                      ? product?.prices_with_tax?.original_price / 4
                      : product?.prices_with_tax?.price / 4
                  ) || ""
                } SAR, and the rest over time`
              : `أو يمكنك دفع  ${
                  truncateToTwoDecimalPlaces(
                    product?.prices_with_tax?.price ==
                      product?.prices_with_tax?.original_price ||
                      product?.prices_with_tax?.discounted_price_to == ""
                      ? product?.prices_with_tax?.original_price / 4
                      : product?.prices_with_tax?.price / 4
                  ) || ""
                } ر.س. الآن، والباقي على دفعات `}
            <Link
              href="/static/tamara"
              target="_blank"
              className="underline cursor-pointer mx-0.5 font-semibold "
            >
              {locale === "en" ? ",Learn more" : "، إعرف أكثر"}
            </Link>
          </p>
        </div>
      ) : null} */}
    </>
  );
};

export default Index;
